module.exports = __webpack_public_path__ + "5ddf941f7f7b28ecb134e1d8b4131634.svg";